import { useMediaQuery, useTheme } from '@mui/material';

export const useBreakpoints = () => {
  const theme = useTheme();

  const fullHD = useMediaQuery(theme.breakpoints.between(1600, 1800));
  const quadHD = useMediaQuery(theme.breakpoints.between(1800, 2600));

  const isMobile = useMediaQuery(theme.breakpoints.down(601));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isLarge = useMediaQuery(theme.breakpoints.down('lg'));
  const isMedium = useMediaQuery(theme.breakpoints.down('xl'));
  const isScreenSmall = useMediaQuery(theme.breakpoints.between(0, 769));
  const isMediumAndSmallDisplay = useMediaQuery(theme.breakpoints.between(0, 1023));

  const xl = quadHD ? 1.7 : fullHD ? 1.9 : 2.35;

  return { xl, theme, isMobile, isTablet, isScreenSmall, isMediumAndSmallDisplay, isLarge, isMedium };
};
